// Synthetic-agent (bot / uptime-monitor / headless / perf-tool) detection by User-Agent.
// Used to skip Grafana Faro RUM init for non-human traffic so synthetic monitors don't
// pollute web-vitals / error-rate / session metrics — the widget wires this at F-5/MR-70.
// Ported verbatim from postv2 (static-app-builder/postv2/src/core/syntheticAgent.js) so the
// two apps' RUM gates share one token set and stay in lockstep.
//
// Substring, case-insensitive: the token matches anywhere in the UA, e.g.
// "PingdomTMS" → pingdom, "HeadlessChrome" → headless, "Chrome-Lighthouse" → lighthouse.
// No `g` flag — `.test()` must stay stateless since this constant is shared.
export const SYNTHETIC_AGENT_RE =
  /bot|crawl|spider|headless|pingdom|phantom|lighthouse|gtmetrix|pagespeed/i;

// True when `userAgent` looks like a bot / synthetic monitor. Falsy input → false:
// a missing UA is treated as a real (just-untagged) client, never a bot.
export function isSyntheticAgent(userAgent) {
  return SYNTHETIC_AGENT_RE.test(userAgent || '');
}
